/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'map-navigation/in': {
    width: 16,
    height: 16,
    viewBox: '0 0 98 98',
    data: '<g data-name="Layer 2"><g data-name="Layer 1"><rect pid="0" width="98" height="98" rx="3.02" _fill="#373a36"/><path pid="1" d="M58.8 48.14l11 11.67h6.25l-8.84-9.33h19.9v-4.67H67.25l8.84-9.33h-6.25z" _fill="#fff"/><path pid="2" d="M66.9 60.43v12H46.39v12.3L21.77 72.39V19.05H66.9v17.43h-4.1V23.16H30l16.41 8.2v36.92H62.8v-7.85z" _fill="#fff"/></g></g>'
  }
})
